export default function isInputEmpty(inputString) {
  if (inputString === "" || inputString === null) {
    return true;
  }
  return false;
}
